import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { Footer } from './Component.js';
import '../../../../shared/esm';
import '../../Context.js';
import '../../../../base-modal/esm';
import '../../ResponsiveContext.js';
import '../../layout.module-99c460df.js';

var styles = {"footer":"side-panel__footer_3ynzp","sticky":"side-panel__sticky_3ynzp"};
require('./mobile.css');

var FooterMobile = function (_a) {
    var _b;
    var className = _a.className, sticky = _a.sticky, _c = _a.layout, layout = _c === void 0 ? 'start' : _c, restProps = __rest(_a, ["className", "sticky", "layout"]);
    return (React.createElement(Footer, __assign({ className: cn(className, styles.footer, (_b = {},
            _b[styles.sticky] = sticky,
            _b)), sticky: sticky, layout: layout }, restProps)));
};

export { FooterMobile };
